import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/landlord/tenant"

export default {
  getSettingsList (id) {
    return Repository.get(`${resource}/${id}/settings`)
  },
  updateSettings (id, payload){
    return Repository.post(`${resource}/${id}/settings`,payload)
  },
  updateTenantCompanyLogo(tenant_id, payload) {
    return Repository.put(`${resource}/${tenant_id}/settings/company_logo`, payload)
  },
  getTenantSequenceList(tenant_id,is_paginate){
    return Repository.get(`${resource}/${tenant_id}/setting/number_sequences?is_paginate=${is_paginate}`)
  },
  getTenantSequence(tenant_id, sequence_id){
    return Repository.get(`${resource}/${tenant_id}/setting/number_sequences/${sequence_id}`)
  },
  updateTenantSequence(tenant_id,sequence_id,payload){
    return Repository.put(`${resource}/${tenant_id}/setting/number_sequences/${sequence_id}`,payload)
  },
}
